import React from 'react';
import Modal from 'react-modal';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import { Helmet } from 'react-helmet';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Terms from '../Terms';
import * as Strings from '../../constants';

class Framework extends React.Component{

  constructor(props) {
    super(props);
    this.state = {
      isPaneOpen: false,
      selectedTerm: '',
      selectedPurpose: 1
    };
  }

  componentDidMount() {
    Modal.setAppElement(this.el);
  }

//  filterRelevantTerms = () => {
//  }


//  buildClass = (p) => {
//    let classname = "phase";
//    if (this.props.phase === p.Nr){
//      classname = "phase active phase-" + p.Nr;
//    }
//    else{
//      classname = "phase light phase-" + p.Nr;
//    }
//    return classname;
//  }

  createTag = (label, purpose1, purpose2, purpose3, purpose4) => {

    let classname ="clickableTag";
    if (
        (this.state.selectedPurpose === 1 & purpose1) ||
        (this.state.selectedPurpose === 2 & purpose2) ||
        (this.state.selectedPurpose === 3 & purpose3) ||
        (this.state.selectedPurpose === 4 & purpose4)
      ){
      classname = "clickableTag active";
    }
    else{
      classname = "clickableTag inactive";
    }
    return(
      <button
        className={classname}
        onClick={() => this.setState({
          isPaneOpen: true,
          selectedTerm: label
        })}
      >
        {label}
      </button>
    );
  }

  createPurpose = (label, purposeNr) => {

    if (this.state.selectedPurpose === purposeNr){
      return(
        <button
          className="clickableTag purpose active"
          onClick={() => this.setState({
            isPaneOpen: true,
            selectedTerm: label
          })}
        >
          {label}
        </button>
      );
    }
    else{
      return(
        <button
          className="clickableTag purpose inactive"
          onClick={() => this.setState({
            selectedPurpose: purposeNr
          })}
        >
          {label}
        </button>
      );
    }
  }

  render() {

    return(
      <div className={"frameworkLayout " + this.state.selectedPurpose} ref={ref => this.el = ref}>

      <Helmet>
        <title>{Strings.Page_Framework + " · " + Strings.Meta_PageTitle}</title>
      </Helmet>



      <Row>
        <Col className="frameworkCol frameworkCol-F">

          {/* COL HEADLINE */}
          <div className="frameworkColHeader">
            <h2>{Strings.FrameworkHeader_F}</h2>
          </div>

          {/* FRAMEWORK CONTENT */}

          <div className="framworkGroup framworkGroup1">
            {this.createTag('Gather data'         , true , true , true , true )}
            {this.createTag('Analyze data'        , true , true , true , true )}
            {this.createTag('Disseminate data'    , true , false, false, true )}
          </div>

          <div className="framworkGroup framworkGroup2">
            {this.createTag('Amplify messages'    , true , true , true , false)}
            {this.createTag('Diversify messages'  , true , true , true , false)}
          </div>

          <div className="framworkGroup framworkGroup3">
            {this.createTag('Connect actors'      , true , true , true , true )}
            {this.createTag('Enable coordination' , false, true , true , true )}
            {this.createTag('Enable collaboration', true , true , true , true )}
          </div>

        </Col>
        <Col className="frameworkCol frameworkCol-arrow">
          <div className="frameworkColHeader">
            <h2>{Strings.FrameworkArrow}</h2>
          </div>
        </Col>
        <Col className="frameworkCol frameworkCol-O">

          {/* COL HEADLINE */}
          <div className="frameworkColHeader">
            <h2>{Strings.FrameworkHeader_O}</h2>
          </div>

          {/* FRAMEWORK CONTENT */}

          <div className="framworkGroup framworkGroup1">
            {this.createTag('Better information'  , true , true , true  , true )}
            {this.createTag('Faster information'  , false, false, false , true )}
            {this.createTag('Wider information'   , true , false, true  , true )}
          </div>

          <div className="framworkGroup framworkGroup2">
            {this.createTag('Political expression', true , true , true , false)}
            {this.createTag('Assert influence'    , false, true , true , false)}
            {this.createTag('Empathy'             , false , false, true , false)}
          </div>
          <div className="framworkGroup framworkGroup3">
            {this.createTag('Mobilization'        , true , true , true , true )}
            {this.createTag('Representation'      , true , true , true , false)}
            {this.createTag('Deliberation'        , true , true , true , false)}
          </div>

        </Col>
        <Col className="frameworkCol frameworkCol-arrow">
          <div className="frameworkColHeader">
            <h2>{Strings.FrameworkArrow}</h2>
          </div>
        </Col>
        <Col className="frameworkCol frameworkCol-P">

          {/* COL HEADLINE */}
          <div className="frameworkColHeader">
              <h2>{Strings.FrameworkHeader_P}</h2>
          </div>

          {/* FRAMEWORK CONTENT */}

          <div className="framworkGroup framworkGroupPurposes">
            {this.createPurpose('Legitimacy and public support', 1)}
            {this.createPurpose('Empowerment', 2)}
            {this.createPurpose('Transforming relations', 3)}
            {this.createPurpose('Risk mitigation and protection', 4)}
          </div>

        </Col>
      </Row>


        <SlidingPane
          className='civil-war'
          overlayClassName='terms-overlay-pane'
          isOpen={this.state.isPaneOpen}
          title={Strings.DrawerTitle}
          subtitle={Strings.DrawerSubtitle}
          width='50vw'
          onRequestClose={ () => {
              // triggered on "<" on left top click or on outside click
              this.setState({ isPaneOpen: false });
          } }>
          <Terms selectedTerm={this.state.selectedTerm}/>
        </SlidingPane>
      </div>
    )
  }
}
export default Framework;




// WEBPACK FOOTER //
// ./src/components/Framework/framework.js